import { Divider } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { usePageVisitHistoryList } from "../hooks/usePageVisitHistoryList";
import { CdpMobileListingCarouselComponent } from "./CdpMobileListingCarousel";

export default function RecentlyViewListingCarousel({
  activity,
  carouselRowNum,
}: {
  activity: ClassDetailsNoSectionsQuery["activity"];
  carouselRowNum: number;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Listings\\Carousels\\RecentlyViewListingCarousel"
  );

  const listings = usePageVisitHistoryList(activity);

  return (
    <>
      {!!listings?.length && (
        <>
          <CdpMobileListingCarouselComponent
            listings={listings}
            carouselRowNum={carouselRowNum++}
            title={t("Recently Viewed")}
          />
          <Divider sx={{ borderColor: "gray100", marginTop: "2.4rem" }} />
        </>
      )}
    </>
  );
}
